import { render, staticRenderFns } from "./ArrowAlert.vue?vue&type=template&id=a9d0c2a8&scoped=true"
import script from "./ArrowAlert.vue?vue&type=script&lang=js"
export * from "./ArrowAlert.vue?vue&type=script&lang=js"
import style0 from "./ArrowAlert.vue?vue&type=style&index=0&id=a9d0c2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d0c2a8",
  null
  
)

export default component.exports